<div *transloco="let t">
	<ng-container>
		<div class="flex flex-col">
			<h3 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
				{{ t('billing.parameterValue.new' + currentParameter.toUpperCase()) }}
			</h3>
			<mat-dialog-content [formGroup]="parameterFg" class="flex flex-col pb-0 overflow-hidden">
				<mat-form-field appearance="outline" class="p-2 w-[50%]">
					<mat-label>{{ t('common.name') }}</mat-label>
					<input formControlName="name" matInput placeholder="{{ t('common.name') }}" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="p-2 w-[50%]">
					<mat-label>{{ t('common.printName') }}</mat-label>
					<input formControlName="printName" matInput placeholder="{{ t('common.printName') }}" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="p-2 w-[50%]">
					<mat-label>{{ t('billing.description') }}</mat-label>
					<input formControlName="description" matInput placeholder="{{ t('billing.description') }}" />
				</mat-form-field>

				<div class="flex flex-row items-center pt-2">
					<div class="flex flex-col">
						<div class="flex flex-row justify-between items-start mx-2 w-72">
							<button
								mat-raised-button
								color="primary"
								class="mb-2"
								(click)="quicksetDateFrom('validFrom', today.toDate())"
								[disabled]="validFromIsUnlimited()">
								{{ t('enum.TODAY') }}
							</button>
							<mat-slide-toggle (change)="unlimitDate($event, 'validFrom')" [checked]="validFromIsUnlimited()" color="primary">
								{{ t('billing.unlimited') }}
							</mat-slide-toggle>
						</div>
						<mat-form-field [ngClass]="!isMobile ? 'mb-4 mx-2' : 'mb-1 w-full'" appearance="outline">
							<mat-label>{{ t('tenantunitDetails.details.validFrom') }}</mat-label>
							<input formControlName="validFrom" [matDatepicker]="dpFrom" [min]="fromMinDate" [max]="toMaxDate" matInput required />
							<mat-error>
								{{ t(parameterFg.errors?.message) }}
							</mat-error>
							<div matSuffix class="flex items-center">
								@if (parameterFg.get('validFrom')?.value) {
									<mat-datepicker-toggle>
										<mat-icon matDatepickerToggleIcon (click)="parameterFg.get('validFrom').setValue(undefined)">clear</mat-icon>
									</mat-datepicker-toggle>
								}
								<mat-datepicker-toggle [for]="dpFrom" matSuffix></mat-datepicker-toggle>
							</div>
							<mat-datepicker #dpFrom></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="flex flex-col">
						<div class="flex flex-row justify-between items-start mx-2 w-72">
							<button
								mat-raised-button
								color="primary"
								class="mb-2"
								(click)="quicksetDateFrom('validTo', today.toDate())"
								[disabled]="validToIsUnlimited()">
								{{ t('enum.TODAY') }}
							</button>
							<mat-slide-toggle (change)="unlimitDate($event, 'validTo')" [checked]="validToIsUnlimited()" color="primary">
								{{ t('billing.unlimited') }}
							</mat-slide-toggle>
						</div>
						<mat-form-field [ngClass]="!isMobile ? 'mb-4 mx-2' : 'mb-1 w-full'" appearance="outline">
							<mat-label>{{ t('tenantunitDetails.details.validTo') }}</mat-label>
							<input formControlName="validTo" [matDatepicker]="dpTo" [max]="toMaxDate" [min]="toMinDate" matInput required />
							<mat-error>
								{{ t(parameterFg.errors?.message) }}
							</mat-error>
							<div matSuffix class="flex items-center">
								@if (parameterFg.get('validTo')?.value) {
									<mat-datepicker-toggle>
										<mat-icon matDatepickerToggleIcon (click)="parameterFg.get('validTo').setValue(undefined)">clear</mat-icon>
									</mat-datepicker-toggle>
								}
								<mat-datepicker-toggle [for]="dpTo" matSuffix></mat-datepicker-toggle>
							</div>
							<mat-datepicker #dpTo></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
				<div class="flex flex-row items-center w-[38.5rem]">
					@if (['setting'].includes(currentParameter)) {
						<mat-form-field appearance="outline" class="p-2 w-[19rem]">
							<mat-label>{{ t('billing.settingType') }}</mat-label>
							<mat-select formControlName="type" name="type" required>
								@for (currentType of translatedSettingTypes; track currentType) {
									<mat-option [value]="currentType.value">
										{{ currentType.label }}
									</mat-option>
								}
							</mat-select>
							<mat-error>
								{{ t('common.requiredField') }}
							</mat-error>
						</mat-form-field>
					}
					@if (['flatrate', 'tariff', 'payment'].includes(currentParameter)) {
						<mat-form-field appearance="outline" class="p-2 w-[19rem]">
							<mat-label>{{ t('billing.periodicity') }}</mat-label>
							<mat-select formControlName="periodicity" name="periodicity">
								@for (currentPeriod of translatedPeriods; track currentPeriod) {
									<mat-option [value]="currentPeriod.value">
										{{ currentPeriod.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
					@if (['share', 'tariff', 'payment'].includes(currentParameter)) {
						<mat-form-field appearance="outline" class="p-2 w-[19rem]">
							<mat-label>{{ t('billing.type') }}</mat-label>
							<mat-select formControlName="type" name="type" required (selectionChange)="onTypeChange($event)">
								@if (['share'].includes(currentParameter)) {
									@for (type of translatedShareTypes; track type) {
										<mat-option [value]="type.value">
											{{ type.label }}
										</mat-option>
									}
								}
								@if (['tariff'].includes(currentParameter)) {
									@for (type of translatedTariffTypes; track type) {
										<mat-option [value]="type.value">
											{{ type.label }}
										</mat-option>
									}
								}
								@if (['payment'].includes(currentParameter)) {
									@for (type of translatedPaymentTypes; track type) {
										<mat-option [value]="type.value">
											{{ type.label }}
										</mat-option>
									}
								}
							</mat-select>
						</mat-form-field>
					}
					@if (['share'].includes(currentParameter)) {
						<mat-form-field appearance="outline" class="p-2 w-[19rem]">
							<mat-label>{{ t('billing.unit') }}</mat-label>
							<mat-select formControlName="unit" name="unit">
								@for (unit of availableUnits(); track unit) {
									<mat-option [value]="unit">
										{{ t('enum.' + unit) }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
					@if (['setting'].includes(currentParameter)) {
						<mat-form-field appearance="outline" class="p-2 w-[19rem]">
							<mat-label>{{ t('billing.validUserRole') }}</mat-label>
							<mat-select formControlName="validUserRole">
								<mat-select-trigger>
									{{ t('enum.' + parameterFg.get('validUserRole')?.value?.userRoleType) }}
									@if (
										parameterFg.get('validUserRole')?.value?.name?.trim()?.length &&
										t('enum.' + parameterFg.get('validUserRole')?.value?.userRoleType) !==
											parameterFg.get('validUserRole')?.value?.name?.trim()
									) {
										({{ parameterFg.get('validUserRole')?.value?.name }})
									}
									@if (parameterFg.get('validUserRole')?.value) {
										<mat-icon
											class="mat-select-clear-icon"
											[matTooltip]="t('commonActions.deleteSelection')"
											(click)="$event.stopPropagation(); parameterFg.get('validUserRole')?.setValue(undefined)">
											clear
										</mat-icon>
									}
								</mat-select-trigger>
								@for (availableUserRole of availableUserRoles(); track availableUserRole.exportId) {
									<mat-option [value]="availableUserRole">
										{{ t('enum.' + availableUserRole.userRoleType) }}
										@if (
											availableUserRole.name?.trim()?.length &&
											t('enum.' + availableUserRole.userRoleType) !== availableUserRole.name?.trim()
										) {
											({{ availableUserRole.name }})
										}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				</div>
			</mat-dialog-content>
			<div class="flex flex-row justify-between items-center">
				<div class="ml-6">
					{{ t('common.markedRequired') }}
				</div>
				<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
					<button (click)="close(false)" mat-raised-button type="button">
						<mat-icon>cancel</mat-icon>
						@if (!layoutService.isMobile()) {
							{{ t('commonActions.cancel') }}
						}
					</button>
					<button (click)="close(true)" [disabled]="!parameterFg.valid" color="primary" mat-raised-button type="submit">
						<mat-icon>check</mat-icon>
						@if (!layoutService.isMobile()) {
							{{ t('common.apply') }}
						}
					</button>
				</mat-dialog-actions>
			</div>
		</div>
	</ng-container>
</div>
